module.exports = "/_next/static/images/EmbraceGoodData@2x-5249813c38ae58733d2e78ae7b351c6f.webp";